<template>
    <div>
        <v-layout
            wrap
        >
            <v-navigation-drawer
                v-model="drawer"
                style="font-family: Roboto, sans-serif"
                width="350"
                fixed
                right
                temporary
                disable-resize-watcher
                class="pt-4"
            >

                <div class="text-xs-center pa-1 mt-0 fixed-header">

                    <h1 class="title font-weight-light">
                        {{ getLabel('commons.client.plural') }} del día
                    </h1>

                    <dialog-date-picker
                        calendar
                        instant-select
                        :value="date"
                        @change="onDateChange"
                        ref="datePicker"/>

                    <v-layout wrap>
                        <v-flex xs12 pa-0>
                            <v-sheet height="3px">
                                <v-progress-linear height="2" indeterminate v-if="loading"/>
                            </v-sheet>
                        </v-flex>
                    </v-layout>

                    <v-layout wrap>
                        <v-flex xs12>
                            <div v-if="!loading && events.length > 0">
                                <v-btn
                                    round small depressed
                                    @click="unattendedOnly=true"
                                    :color="unattendedOnly ? 'primary' : 'default'">En espera
                                    ({{ events.filter(evt => evt.event_status.id === 3).length }})
                                </v-btn>

                                <v-btn
                                    round small depressed
                                    @click="unattendedOnly=false"
                                    :color="!unattendedOnly ? 'primary' : 'default'">Todos ({{ events.length }})
                                </v-btn>

                                <v-btn @click="getEvents" round small icon depressed color="accent" :loading="loading">
                                    <v-icon small>mdi-refresh</v-icon>
                                </v-btn>
                            </div>
                        </v-flex>
                    </v-layout>
                </div>

                <div class="list-container">
                    <v-slide-y-transition>
                        <template v-if="!loading">
                            <div class="mt-1">

                                <v-list two-line>

                                    <div v-if="items.length === 0" class="caption mx-auto text-xs-center mt-3">
                                        No hay {{ getLabel('commons.client.plural').toLowerCase() }} en esta lista
                                    </div>

                                    <template v-for="(event, index) in items">
                                        <v-divider/>
                                        <attention-event-list-item
                                            @click:appointment="onAppointmentClick(event)"
                                            :key="index"
                                            :event="event"/>
                                    </template>

                                </v-list>
                            </div>
                        </template>
                    </v-slide-y-transition>
                </div>


            </v-navigation-drawer>
            <v-snackbar
                style="font-family: Roboto, sans-serif"
                v-model="snackBar"
                :color="snackBarColor"
                top
                :timeout="7000"
                @click="snackBarClick"
            >
                {{ snackBarText }}
                <v-btn
                    color="white"
                    flat
                    @click="snackBar = false"
                >
                    Cerrar
                </v-btn>
            </v-snackbar>
        </v-layout>
    </div>

</template>

<script>

import AttentionEventListItem from '@/components/appointments/AttentionEventListItem'
import {mapMutations, mapState} from 'vuex'

import {ApiUtils} from '@/utils/ApiUtils'
import {getLabel} from '@/utils/Institution'
import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'

import DialogDatePicker from '@/components/common/DialogDatePicker'

export default {
    components: {
        AttentionEventListItem,
        DialogDatePicker
    },
    props: {
        specialistId: {
            type: Number
        },
        individualProvider: {
            type: Boolean,
            default: false
        }
    },
    data(vm) {
        return {

            snackBar: false,
            snackBarColor: 'primary',
            snackBarText: '',
            snackBarClick: () => {
            },

            date: vm.$moment().format('YYYY-MM-DD'),

            loading: false,
            unattendedOnly: true,
            events: [],
            schedule: null

        }
    },
    mounted() {
        var vm = this
        vm.getEvents()
        const channel = `specialist.${vm.specialist}.appointments`
        leaveChannel(channel)
        subscribeToPrivateChannelEvents(channel, {
            'ClientAttentionStart': vm.onClientAttentionStart,
            'ClientAttentionEnd': vm.onClientAttentionEnd,
            'EventCancelled': vm.onEventCancelled,
            'ClientArrived': vm.onClientArrive,
            'AppointmentCreated': vm.onAppointmentCreated,
        })
    },
    beforeRouteLeave(to, from, next) {
        var vm = this
        vm.leaveSockets()
        next()
    },
    beforeDestroy() {
        var vm = this
        vm.setEvent(null)
        if (vm.schedule) {
            vm.leaveSockets()
        }
    },
    methods: {
        ...mapMutations(['showSnackBar', 'showClientList', 'hideClientList']),
        ...mapMutations('clientAttention', [
            'setEvent'
        ]),
        getLabel,
        leaveSockets() {
            var vm = this
            const channel = `specialist.${vm.specialist}.appointments`
            leaveChannel(channel)
        },
        showDatePicker() {
            this.$refs.datePicker.show()
        },
        onDateChange(date) {
            this.date = date
        },
        onAppointmentClick(event) {
            var vm = this
            vm.setEvent(event)
        },
        formatEvent(event) {
            const evt = JSON.parse(JSON.stringify(event))
            evt.time = this.$moment(event.time, 'HH:mm').format('HH:mm')
            return evt
        },
        onEventCancelled({event}) {


            var vm = this

            vm.snackBarClick = () => {
                vm.unattendedOnly = false
                vm.showClientList()
            }


            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            if (eventIndex !== -1) {
                const message = `Se ha cancelado la cita de las ${vm.$moment(event.time, 'HH:mm').format('HH:mm')}`
                vm.notify(message, 'pink')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            }

        },
        onClientArrive({event}) {


            var vm = this
            vm.snackBarClick = () => {
                vm.unattendedOnly = true
                vm.showClientList()
            }

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            const message = `${event.client.first_name} ${event.client.last_name} (${vm.$moment(event.time, 'HH:mm').format('HH:mm')}) ha llegado`
            if (eventIndex !== -1) {
                vm.notify(message, 'green')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            } else {
                if (event.date === vm.date) {
                    vm.notify(message, 'green')
                    vm.events.push(vm.formatEvent(event))
                }
            }

        },
        onClientAttentionStart({event}) {


            var vm = this
            vm.snackBarClick = () => {
            }

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            const message = `La atención de ${event.client.first_name} ${event.client.last_name} ha comenzado`
            if (eventIndex !== -1) {
                vm.notify(message, 'green')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            } else {
                if (event.date === vm.date) {
                    vm.notify(message, 'green')
                    vm.events.push(vm.formatEvent(event))
                }
            }

        },
        onClientAttentionEnd({event}) {


            var vm = this
            vm.snackBarClick = () => {
            }

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            const message = `La atención de ${event.client.first_name} ${event.client.last_name} ha finalizado`
            if (eventIndex !== -1) {
                vm.notify(message, 'green')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            } else {
                if (event.date === vm.date) {
                    vm.notify(message, 'green')
                    vm.events.push(vm.formatEvent(event))
                }
            }

        },
        onAppointmentCreated({event}) {


            var vm = this

            const eventIndex = vm.events.findIndex(evt => {
                return evt.id === event.id
            })

            if (eventIndex !== -1) {

                vm.snackBarClick = () => {
                    vm.unattendedOnly = false
                    vm.showClientList()
                }

                const message = `Se ha vuelto a agendar la hora de las (${vm.$moment(event.time, 'HH:mm').format('HH:mm')})`
                vm.notify(message, 'blue')
                vm.events.splice(eventIndex, 1, vm.formatEvent(event))
            } else {
                if (event.date === vm.date) {
                    vm.events.push(vm.formatEvent(event))
                }
            }
        },
        notify(message = '', color = '') {
            var vm = this
            vm.snackBarText = message
            vm.snackBarColor = color
            vm.snackBar = true
        },
        async getEvents() {

            var vm = this
            if (vm.loading) return
            if ((vm.individualProvider && !vm.currentProvider) ||
                !vm.individualProvider && (!vm.currentProvider || !vm.currentBranchOffice)) {
                return
            }

            vm.loading = true
            const url = vm.individualProvider ?
                `provider/${vm.currentProvider.id}/appointments` :
                `provider/${vm.currentProvider.id}/branch-office/${vm.currentBranchOffice.id}/appointments`

            var response = await ApiUtils.makeGet(url, {
                date: vm.date,
                // status: vm.selectedAppointmentStatus.map(item => item.id),
                specialists: [vm.specialist] || []
            })
            vm.loading = false

            if (!response.ok) {
                const json = await response.json()
                vm.showSnackBar(json.message || 'Ha ocurrido un error intentando consultar citas')
                return
            }

            const json = await
                response.json()
            vm.events = json.result.appointments.data
        }
    },
    computed: {
        ...mapState([
            'currentUser',
            'currentProvider',
            'currentBranchOffice',
            'clientListIsVisible']),
        drawer: {
            get() {
                return this.clientListIsVisible
            },
            set(val) {
                val ? this.showClientList() : this.hideClientList()
            }
        },
        specialist() {
            var vm = this
            if (!vm.currentUser) return null
            return vm.specialistId || vm.currentUser.id
        },
        items() {
            var vm = this
            if (vm.unattendedOnly) {
                return vm.events.filter(event => {
                    return event.event_status_id === 3
                }).sort((a, b) => vm.$moment(
                    a.time, 'HH:mm') - vm.$moment(b.time, 'HH:mm')
                )
            }

            return vm.events.sort((a, b) => vm.$moment(
                a.time, 'HH:mm') - vm.$moment(b.time, 'HH:mm')
            )

        }
    },
    watch: {
        date() {
            this.getEvents()
        },
        events(val) {
            if (val && val.length > 0) {
                this.schedule = val[0].schedule_id || val[0].schedule.id
            }
        },
        schedule(val, oldVal) {
        },
        currentBranchOffice(val) {
            this.getEvents()
        }
    }
}

</script>

<style scoped>

.fixed-header {
    position: fixed !important;
    text-align: center;
    background-color: rgba(255, 255, 255, .9);
    z-index: 100;
    width: 100%;
}

.list-container {
    margin-top: 100px;
    height: calc(100% - 100px);
    overflow-y: auto;
    overflow-x: hidden;
}
</style>